/**
 * Transform WYSIWYG buttons into complete button structure
 */
document.addEventListener("DOMContentLoaded", function () {
    const wysiwygButtons = document.querySelectorAll(".button-wysiwyg");

    wysiwygButtons.forEach(function (button) {
        // Get the current text content
        const buttonText = button.textContent || button.innerText;

        // Create the complete button structure
        button.innerHTML = `
            <span class="ellipse"></span>
            <span class="ellipse"></span>
            <span class="ellipse"></span>
            <span class="title">${buttonText}</span>
        `;

        // Remove the wysiwyg class as it's no longer needed
        button.classList.remove("button-wysiwyg");
    });
});
